import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Login from "./pages/auth/Login";
import Dashboard from "./components/Dashboard";
import UserManagement from "./components/UserManagement";
import GroupManagement from "./components/GroupManagement";
import Department from "./components/Department";
import TransactionList from "./components/TransactionList";
import Transaction from "./components/Transaction";
import MasterTransaction from "./components/MasterTransaction";
import FieldMaster from "./components/FieldMaster";
import FieldMasterlList from "./components/FieldMasterlList";
import FieldMasterProjections from "./components/FieldMasterProjections";
import Layout from "./hoc/Layout";
import "./App.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    setIsLoggedIn(!!token);
    setLoading(false);
  }, []);

  function ProtectedRoute({ children }) {
    const location = useLocation();
    if (!isLoggedIn) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
  }

  const handleLogin = (userData) => {
    setIsLoggedIn(true);
    setCurrentUser(userData);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard currentUser={currentUser} />} />
          <Route
            path="users"
            element={<UserManagement currentUser={currentUser} />}
          />
          <Route
            path="roles"
            element={<GroupManagement currentUser={currentUser} />}
          />
          <Route
            path="departments"
            element={<Department currentUser={currentUser} />}
          />
          <Route path="/transactions" element={<TransactionList />} />
          <Route path="/transactions/new" element={<Transaction />} />
          <Route
            path="/transactions/master/new"
            element={<MasterTransaction />}
          />
          <Route
            path="/transactions/master/edit/:id"
            element={<MasterTransaction />}
          />
          <Route
            path="/transactions/master/view/:id"
            element={<MasterTransaction />}
          />
          <Route path="/transactions/edit/:id" element={<Transaction />} />
          <Route path="/transactions/view/:id" element={<Transaction />} />
          <Route
            path="/field-master"
            element={<FieldMasterlList currentUser={currentUser} />}
          />
          <Route path="/field-master/new" element={<FieldMaster />} />
          <Route path="/field-master/edit/:id" element={<FieldMaster />} />
          <Route
            path="/field-master/projections"
            element={<FieldMasterProjections />}
          />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
